import { useFormContext } from 'react-hook-form'
import { useEffect } from 'react'
import { ORDER_STATUS } from 'utils/constants'

const OrderStatusConfiguration = () => {
  const { setValue, watch } = useFormContext()
  const allowedStatuses = watch('mobile.allowedOrderStatuses') || []

  // Initialize empty array if not already set
  useEffect(() => {
    if (!allowedStatuses || !Array.isArray(allowedStatuses)) {
      setValue('mobile.allowedOrderStatuses', [])
    }
  }, [])

  const handleStatusToggle = (status: string) => {
    const isSelected = allowedStatuses.includes(status)
    const newAllowedStatuses = isSelected
      ? allowedStatuses.filter((s: any) => s !== status)
      : [...allowedStatuses, status]

    setValue('mobile.allowedOrderStatuses', newAllowedStatuses)
  }

  const allOrderStatuses = Object.values(ORDER_STATUS)

  return (
    <div className="mt-6 rounded-lg border border-gray-300 bg-gray-50 p-4">
      <h3 className="mb-4 font-semibold">Order Status Filter Configuration</h3>
      <p className="mb-4 text-sm text-gray-600">
        Select which order statuses should be available as filters in the mobile
        app.
      </p>

      <div className="grid grid-cols-2 gap-3 md:grid-cols-3">
        {allOrderStatuses.map((status) => (
          <div key={status} className="flex items-center">
            <input
              type="checkbox"
              id={`status-${status}`}
              checked={allowedStatuses.includes(status)}
              onChange={() => handleStatusToggle(status)}
              className="h-4 w-4 rounded border-gray-300 text-black accent-black focus:ring-black"
            />
            <label
              htmlFor={`status-${status}`}
              className="ml-2 text-sm font-medium text-gray-700"
            >
              {status}
            </label>
          </div>
        ))}
      </div>
    </div>
  )
}

export default OrderStatusConfiguration
